(ns teamoesterreich.user-mode.landing.app-panel.login
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    ))



(defn is-online []
  (let [!actual-user (r/cursor store/app-state [:actual-user])]
    [mui/paper {:style   {:textAlign "left" :cursor "hand" :marginTop "7px"}
                :class   "app-panel"
                :onClick #(a/set-page :profile)}
     [:div {:class "app-panel-img"}
      [:img {:src "/custom/img/login.png" :alt "t-man"}]
      ]
     [:div
      {:class "app-panel-content"}
      [:div {:class "app-panel-title"}
       (txt/transl "Ich im Team")
       ;[warning {:style {:color "red"}}]
       ]
      [:div {:class "app-panel-toe-name"}
       (str
         (get-in @!actual-user [:name :title]) " "
         (get-in @!actual-user [:name :first]) " "
         (get-in @!actual-user [:name :last])) " "

       ]
      [:button
       {:class "profile-button"

        }
       (txt/transl "Profil öffnen")]
      ]
     ]))

(defn login []
  [mui/paper {:style   {:textAlign "left" :cursor "hand" :backgroundColor (txt/txt :style :main-color) :color "white" :height "90px" :marginTop "7px"}
              :class   "app-panel"
              :onClick #(a/open-login)}
   [:div {:class "app-panel-img"}
    [:img {:src "/custom/img/tmann_white.png" :alt "t-man"}]
    ]
   [:div
    {:class "app-panel-content" :style {:color "white"}}
    [:div {:class "app-panel-title"} (txt/transl "Ich will ins Team")]
    [:br]
    [:button
     {:class "join-button clickable"}
     (txt/transl "MITMACHEN")]]
   ])

(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])]
    (if (:tom-id @!actual-user)
      (is-online)
      (login)
      )))

